import React, { Component, Fragment } from 'react';
import { arrayOf, object, string } from 'prop-types';
import classnames from 'classnames/bind';

import styles from './DataTable.css';

class DataTable extends Component {
  static propTypes = {
    data: arrayOf(object).isRequired,
    columns: arrayOf(object).isRequired,
    className: string
  }

  renderTableHeader = () => {
    const { columns } = this.props;
    const cx = classnames.bind(styles);

    return (
      <div className={styles.tableRow}>
        {columns.map((column, i) => {
          const classes = cx('tableCell', { 'grow': column.flexGrow } );

          return (
            <div
              className={classnames(classes, column.class)}
              key={i}
            >
              <label>{column.header}</label>
            </div>
          );
        })}
      </div>
    );
  }

  renderTableData = () => {
    const { data } = this.props;

    return (
      <Fragment>
        {data.map((row, i) => this.renderTableRow(row, i))}
      </Fragment>
    );
  }

  renderTableRow = (row, key) => {
    const { columns } = this.props;
    const cx = classnames.bind(styles);

    return (
      <div className={styles.tableRow} key={key}>
        {columns.map((column, index) => {
          const classes = cx('tableCell', { 'grow': column.flexGrow } );

          return (
            <div
              className={classnames(classes, column.class)}
              key={index}
            >
              {row[column.key]}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { className, ...rest } = this.props;

    return (
      <div className={classnames(styles.table, className)} {...rest}>
        <div className={styles.tableHead}>
          {this.renderTableHeader()}
        </div>
        <div className={styles.tableBody}>
          {this.renderTableData()}
        </div>
      </div>
    );
  }
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTable.js